import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["width", "height", "fill"];
import React from 'react';

var PoundIcon = function PoundIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1em' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '1em' : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#333' : _ref$fill,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: fill,
    fillRule: "evenodd",
    d: "M11 22c6.075 0 11-4.925 11-11S17.075 0 11 0 0 4.925 0 11s4.925 11 11 11zm0-1.571A9.429 9.429 0 1 1 11 1.57a9.429 9.429 0 0 1 0 18.858zm-2.112-5.093c-.053 0-.064-.027-.032-.08.48-.459.72-1.11.72-1.952v-1.84c0-.043.021-.064.064-.064h3.072c.107 0 .16-.053.16-.16v-.624c0-.107-.053-.16-.16-.16H9.64c-.043 0-.064-.021-.064-.064V8.12c0-.693.181-1.221.544-1.584.363-.363.875-.544 1.536-.544.437 0 .8.112 1.088.336.299.213.528.555.688 1.024.032.075.08.112.144.112h.048l.784-.144c.085-.021.128-.064.128-.128l-.016-.064c-.224-.683-.576-1.205-1.056-1.568-.48-.373-1.072-.56-1.776-.56-1.013 0-1.808.277-2.384.832-.576.555-.864 1.323-.864 2.304v2.256c0 .043-.021.064-.064.064H7.16c-.107 0-.16.053-.16.16v.624c0 .107.053.16.16.16h1.216c.043 0 .064.021.064.064v1.872c0 .448-.075.843-.224 1.184-.15.341-.357.592-.624.752a.208.208 0 0 0-.112.192v.704c0 .107.053.16.16.16h6.848c.107 0 .16-.053.16-.16v-.672c0-.107-.053-.16-.16-.16h-5.6z",
    clipRule: "evenodd"
  }));
};

PoundIcon.displayName = 'PoundIcon';
export default PoundIcon;